export default {
  rule: {
    title: '报名规则',
    productCriteria: '候选商品准入条件',
    type: '库存类型',
    FBKLabel: 'FBK【海外仓备货】',
    GSLabel: 'GS【本地虚拟仓】',
    DSLabel: 'DS【本地虚拟仓】',
    PUBLabel: 'PUB【本地虚拟仓】',
    category: '禁报类目',
    keywords: '禁报关键词',
    pStatus: '商品状态',
    pStatusValue: '正常上架可销售商品',
    iStatus: '库存状态',
    iStatusValue: '可售库存',
    sStatus: '店铺状态',
    sStatusValue: '非冻结、歇业、已关闭店铺',
    requirement: '销量要求',
    Limit: '报名频次限制',
    eachOf: '每个店铺1天内最多报名',
    listingDay: '个Listing商品',
    ForOf: '同一个Listing商品1天内最多报名',
    sessionDay: '个场次',
    registrationCriteria: '提报准入条件',
    inventoryRequirements: '库存数量要求',
    FBKQuantity: 'FBK SKU库存数>= ',
    GSQuantity: 'GS SKU库存数>= ',
    DSQuantity: 'DS SKU库存数>= ',
    PUBQuantity: 'PUB SKU库存数>= ',
    ifInventorySuffice: '如库存数量要求包含两种以上库存类型, 则满足其中任一即可',
    registrationRequirements: '报名价格要求',
    qtyRequirements: ' 库存数量要求',
    theLeast: '报名价格必须低于最近',
    belowLast: '天内最低价售出价的',
    days: '以上',
    lowerLast: '天内的最低售出价低',
    ifPriceSuffice: '如价格要求包含两种以上, 则满足其中任一即可'
  },
  applicationList: {
    title: '秒杀报名',
    errorTip: '不可报名原因：',
    rule: '报名规则',
    pName: '商品标题',
    category: '商品类目',
    all: '全选',
    pInformation: '商品信息',
    priceRange: '价格范围',
    inventory: '库存',
    apply: '报名'
  },
  applicationManage: {
    title: '秒杀管理',
    statu: '活动状态',
    oPrice: '原销售价',
    ePrice: '秒杀价',
    eInventory: '秒杀库存',
    eSold: '秒杀销量',
    sTime: '开始时间',
    operation: '操作',
    btnView: '商品详情',
    btnCancel: '取消报名',
    btnEditor: '编辑活动商品',
    btnReason: '未通过原因',
    deleteBoxTitle: '确认取消报名吗？',
    deleteBoxConfirm: '确认',
    deleteBoxCancel: '取消'
  },
  application: {
    reselectProducts: '重选商品',
    stateSubmitted: '已提交',
    statePending: '待提交',
    title: '编辑活动商品信息',
    purchaseLimitMode: '限购方式',
    radioPurchase: '单次单件',
    radioPerson: '单人单件',
    radioLimited: '无限制',
    expectedTime: '期望场次',
    selectDate: '选择日期',
    selectStartSession: '请选择场次',
    disableVoucher: '禁用优惠券',
    InventoryType: '库存类型',
    batchSettings: '批量设置',
    discount: '百分比',
    fixedAmount: '固定金额',
    reduce: '降价',
    setPriceInBatch: '批量设置价格， 请填写整数',
    setInventoryInBatch: '批量设置',
    setInventoryInBatchEnd: '库存',
    confirm: '确认',
    specification: '商品规格',
    lowestLast: '',
    day: '天',
    daysPrice: '内最低销售价(不包含秒杀价)',
    currentPrice: '当前售价',
    inventory: '商品库存',
    eventInventory: '秒杀库存',
    eventPrice: '秒杀价',
    submit: '提交',
    yes: '是',
    no: '否',
    expectedTimeMsg: '请选择期望场次',
    fbkPlaceholder: 'FBK库存须',
    pubPlaceholder: '库存须',
    nullStore: '库存不足',
    min: '>=',
    max: ',<= ',
    pricePlaceholder: '请输入秒杀价',
    skuNullMsg: '提交前请选择SKU',
    the: '',
    priceOrQtyNull: '不符合价格/库存数量的注册标准。 请重新填写表格。',
    priceTip: '你设置的秒杀价格过低, 存在亏本风险, 是否确认'
  },
  details: {
    title: '活动商品信息',
    startDate: '开始时间'
  },
  msg: {
    successfully: '提交成功'
  },
  title: {
    flashSaleList: '秒杀申请列表',
    flashSaleApplication: '秒杀申请',
    rule: '秒杀规则',
    flashSaleManage: '秒杀管理',
    flashSaleDetails: '秒杀详情'
  }
}
